import { render } from "./TheC01ItemFormNotePanelDrink.vue?vue&type=template&id=72576d45&scoped=true&ts=true"
import script from "./TheC01ItemFormNotePanelDrink.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemFormNotePanelDrink.vue?vue&type=script&lang=ts"

import "./TheC01ItemFormNotePanelDrink.vue?vue&type=style&index=0&id=72576d45&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72576d45"]])

export default __exports__